import React from "react";
import image from "../assets/home/react-home.svg";
import styled from "styled-components";

function Home() {
  const HomeC = styled.section`
    position: absolute;
    overflow-x: hidden;
    height: auto;
    display: flex;
    box-sizing:border-box;

    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 100vh;
    @media (max-width: 450px) {
      width: 100%;
      .container {
        display: flex;

        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 80%;
        h2 {
          font-family: Nunito;
          font-style: normal;
          font-weight: bold;
          font-size: 33px;
          line-height: 45px;

          color: #8e97f8;
          margin-bottom: 0px;
        }}
        img {
          margin: auto;
        }
        p {
          margin-top: 10px;
          font-family: Nunito;
          font-style: normal;
          font-weight: bold;
          font-size: 14px;
          line-height: 27px;

          color: #ffffff;

          .hello {
            color: #ab3136;
          }
          .iam {
            color: #a2d560;
          }
        }
        img {
          width: 100%;
          height: 153px;
        }
        h3 {
          color: #fff;
        }
        .education {
          text-align: center;
          display: flex;
          flex-direction: column;
          gap: 1em;
        }
        .ghost {
          width: 100%;
          height: 59px;
        }
        a {
          width: 100%;
          height: auto;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      @media (min-width: 450.1px) and (max-width: 1000px) {
        width: 100%;
        .container {
          padding-right: 100px;
          display: flex;

          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 100%;
          h2 {
            width: 70%;
            font-family: Nunito;
            font-style: normal;
            font-weight: bold;
            font-size: 57px;
            line-height: 96px;
            color: #8e97f8;
            margin-bottom: 0px;
          }
        }
        img {
          margin: auto;
        }
        p {
          width: 70%;
          margin-top: 10px;
          font-family: Nunito;
          font-style: normal;
          font-weight: bold;
          font-size: 19px;
          line-height: 32px;
          color: #ffffff;
        

        .hello {
          color: #ab3136;
        }
        .iam {
          color: #a2d560;
        }
      }
      img {
        float: right;
        width: 300px;
      }
      h3 {
        font-size: 40px;
        color: #fff;
      }
      .education {
        text-align: center;
        display: flex;
        flex-direction: column;
        gap: 1em;
      }
      .ghost {
        width: 100%;
        height: 59px;
      }
      a {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    @media (min-width: 1000.1px) {
      width: 100%;
      .container {
        display: flex;

        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 80%;
        h2 {
          font-family: Nunito;
          font-style: normal;
          font-weight: bold;
          font-size: 87px;
          line-height: 96px;
          color: #8e97f8;
          margin-bottom: 0px;
        }
      }
      img {
        margin: auto;
      }
      p {
        margin-top: 10px;
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 46px;
        line-height: 58px;
        color: #ffffff;

        .hello {
          color: #ab3136;
        }
        .iam {
          color: #a2d560;
        }
      }
      img {
        float: right;
        width: 500px;
      }
      h3 {
        font-size: 70px;
        color: #fff;
      }
      .education {
        text-align: center;
        display: flex;
        flex-direction: column;
        gap: 1em;
      }
      .ghost {
        width: 100%;
        height: 59px;
      }
      a {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    a {
      text-decoration: none;
      .download {
       padding:25px 45px;
       display:grid;
       place-items:center;
       
       
        color: #ffcf49;
        background-color: #3a4449;
        border-radius: 10px;
        border: none;

        filter: drop-shadow(2px 2px 4px black);
      }
    }
  `;
  return (
    <>
      <HomeC>
        <div className="container">
          <div className="ghost"></div>
          <h2>Web developer</h2>

          <p>
            {" "}
            About me
            <b className="hello"> Hello</b>,{" "}
            <b className="iam">I am Francisco Jimenez</b>, I'm a programmer
            passionate about developing competent software that translates into
            business opportunities and, I'm willing to work on new projects and
            vacancies that these generate. I am confident that creating
            effective, understandable, scalable and efficient software is an
            excellent way to address many of the needs of organizations and
            society while generating value in the process.
            <img src={image} />
            More about me I am a programmer passionate about discovering and
            developing new technologies and enjoy the study of them, I am a
            person committed to my work that generates me fulfillment with what
            I do.
          </p>
          <h3> My education</h3>
          <p className="education">
            <b className="iam">
              Universidad Autónoma Metropolitana Azcapotzalco:Computer
              Engineering{" "}
            </b>
            2020
            <b className="iam">
              Centro de Bachillerato tecnologico Industrial y de servicios
              No.59: Programming Technician
            </b>
            2017-2020
          </p>
          <a
            target="_blank"
            href="https://pamsho-data.s3.us-east-2.amazonaws.com/Profile_de2640f6df.pdf"
          >
            <button className="download">Download cv</button>{" "}
          </a>

          <div className="ghost"></div>
          <div className="ghost"></div>
        </div>
      </HomeC>
    </>
  );
}

export default Home;
